const REQUEST_TYPES = {
  STORE: 'store',
  VERIFY: 'verify'
};

export const THANK_YOU_TEXT = {
  [REQUEST_TYPES.STORE]: 'idv.thank_you_text_store',
  [REQUEST_TYPES.VERIFY]: 'idv.thank_you_text_verify',
  default: 'idv.thank_you_text_verify'
};

export const IDV_DOC_TYPES = {
  SELFIE: 'selfie',
  FRONT: 'front',
  BACK: 'back'
};

export const ACTION_TYPES = {
  SAVE: 'save',
  CLEAR: 'clear'
};

export const CAMERA_CANVAS_DIMENSIONS = {
  width: 413,
  height: 310
};

export const ERROR_500_PROPS = {
  firstTitleKey: 'errorPage500.500',
  secondTitleKey: 'errorIdv.try_again_later',
  textKey: 'errorIdv.continue_receive_message',
  imageName: 'error-page-icon-v2.svg'
};

export const EXPIRED_PROPS = {
  firstTitleKey: 'idv.expired_title',
  textKey: 'idv.expired_text',
  imageName: 'expired-page-icon-v2.svg',
  ctaButtonTextKey: 'buttonTexts.cancel_and_go_back'
};

export const IDV_FORM_FIELDS = {
  country: 'country',
  document: 'document'
};

export const LIVENESS_CHECK_ERROR_CODES = [
  'FACE_TOO_CLOSE',
  'FACE_CLOSE_TO_BORDER',
  'FACE_NOT_FOUND',
  'TOO_MANY_FACES',
  'FACE_TOO_SMALL',
  'INVALID_IMAGE',
  'SCREEN_REPLY',
  'PAPER_COPY',
  'UNKNOWN'
];

export enum Views {
  desktop = 'desktop',
  mobile = 'mobile'
}

export const SECUREME_IFRAME_DIMENSIONS = {
  [Views.desktop]: {
    width: 1200,
    height: 650
  },
  [Views.mobile]: {
    width: '100%',
    height: 650
  }
};

export enum FacingMode {
  user = 'user',
  environment = 'environment'
}

export const SECUREME_SUCCESS_EVENT = 'success';

export enum SECUREME_LOCALE_EVENTS {
  clickedOnLanguage,
  'Locale set to browser locale'
}
